import { createContext } from 'react';
import { User } from 'src/utils/gql/types';

export interface AccountContextType {
  user: User;
}

export const defaultValue: User = {
  firstName: '',
  lastName: '',
  id: '',
  email: '',
  role: '',
  deckStudioEnabled: false,
  company: {
    name: '',
    industry: '',
    usageOptions: [],
    companyDescription: '',
    id: '',
  },
};

export const AccountContext = createContext<AccountContextType>({
  user: defaultValue,
});

AccountContext.displayName = 'AccountContext';
